import React, { useState } from 'react';
import { Text, Space, Button, InputField, Conditional, ConfirmModal, Icon, Popup } from '@cashfree-intl/coherent';
import CustomIcons from 'components/CustomIcons';
import CopyToClipboard from 'components/CopyToClipboard';
import { PLACEHOLDER_TEXT } from 'utils/constants';
import { StyledChip, StyledCopyToClipboard, StyledEndpointText, StyledRetryMessage, StyledSpace, StyledSummaryPaper, SummaryStyledInputWrapper } from '../styled';
import { generateRandomKey, getRetryMessage } from '../helpers';
import { ABANDONED_CHECKOUT_DOC } from '../constants';

const Summary = ({ policyListData, endpointDetails, checkedItems, abandonedCheckoutSecretKey, saveAbandondedCheckoutSecretKey }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleGenerateSecretKey = () => {
        if (abandonedCheckoutSecretKey) {
            setIsModalVisible(true);
        } else {
            const randomKey = generateRandomKey();
            saveAbandondedCheckoutSecretKey({ 
                data: { configKey: 'ABANDONED_CHECKOUT_SECRET', configValue: randomKey } 
            })
        }
    };

    const handleModalConfirm = () => {
        const randomKey = generateRandomKey();
        saveAbandondedCheckoutSecretKey({ 
            data: { configKey: 'ABANDONED_CHECKOUT_SECRET', configValue: randomKey },
            cb: () => { setIsModalVisible(false) }, 
            mode: 'EDIT' 
        })
    };

    const handleModalCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <Text variant="h16" strong>
                Summary
            </Text>
            <Space gap={2.2} className="mt-2">
                <StyledEndpointText variant='b14' color="bodyLight" >Endpoint URL </StyledEndpointText>
                <Text strong> {endpointDetails?.channelValue || PLACEHOLDER_TEXT}</Text>
            </Space>
            <Space gap={6} className="mt-1">
                <Text color="bodyLight">Select Webhook Version </Text>
                <Text strong> {endpointDetails?.cfApiVersion || PLACEHOLDER_TEXT}</Text>
            </Space>

            <Conditional if={isModalVisible}>
                <ConfirmModal
                    title="Update Secret Key"
                    confirmText="Update"
                    onClose={handleModalCancel}
                    onConfirm={handleModalConfirm}
                    confirmBtnEvent="Primary_Button_Update_Secret_Key_Confirm"
                    closeBtnEvent="Link_Button_Update_Secret_Key_Cancel"
                    closeCrossEvent="Update_Secret_Key_Icon_Close"
                >
                    Are you sure you want to update the secret key? This will invalidate the previous key and require updates for all webhook consumers
                </ConfirmModal>
            </Conditional>
            {policyListData?.map((policyData, index) => {
                return (<StyledSummaryPaper className="accordion-policy-timeline mt-2" >
                    <Text variant="h16" strong>
                        Policy {index + 1}  {checkedItems[index].length <= 0 && <StyledChip as='span' variant='b14'>User Action Pending</StyledChip>}
                    </Text>
                    <Space gap={3} className=" mt-2">
                        <Text color="bodyLight">Retry Policy :</Text>
                        <Text strong> {policyData?.retryType}</Text>
                    </Space>
                    <StyledSpace gap={7} className="mt-1">
                        <Text color="bodyLight">Events :</Text>
                        {checkedItems[index].length ? <Text strong> {checkedItems[index].join(',')}</Text> : <Text variant="b14" color="warning" >
                            <CustomIcons componentName='PENDING' /> No Events Added
                        </Text>}
                    </StyledSpace>
                    <StyledRetryMessage variant='b14'>
                        {getRetryMessage(policyData)}
                    </StyledRetryMessage>
                    <Conditional if={checkedItems.some(item => item.includes('abandoned checkout'))}>
                        <Space direction='column' className="mt-2">
                            <Space alignItems='center' gap={1} className='mb-1'>
                                <Text color="bodyLight">
                                    Secret Key
                                </Text>
                                <Popup position="right center" content="This key is ONLY for the abandoned checkout webhooks you will receive on this URL." trigger={<span><Icon name='info-small' width={16} height={16} /></span>} />
                            </Space>
                            <SummaryStyledInputWrapper>
                                <InputField
                                    name="configValue"
                                    value={abandonedCheckoutSecretKey}
                                    placeholder="Generate Secret Token for abandoned checkout"
                                    disabled
                                    fluid
                                />
                                {abandonedCheckoutSecretKey && (
                                    <StyledCopyToClipboard>
                                        <CopyToClipboard
                                            selectedText={abandonedCheckoutSecretKey}
                                            successPopupText="Secret key copied!"
                                        />
                                    </StyledCopyToClipboard>
                                )}
                                <Button type="button" secondary onClick={handleGenerateSecretKey}>
                                    {!abandonedCheckoutSecretKey ? 'Generate Secret Key' : 'Update Secret Key'}
                                </Button>
                            </SummaryStyledInputWrapper>
                            <Text color="bodyLight" className="mt-1">
                                Pass the key to your system to authenticate webhook messages.{' '}
                                <a
                                    target="_blank"
                                    href={ABANDONED_CHECKOUT_DOC}
                                    data-event-name="abandoned_checkout_link"
                                    rel="noopener noreferrer"
                                >
                                    Read more
                                </a>
                            </Text>
                        </Space>
                    </Conditional>
                </StyledSummaryPaper>)
            })
            }
        </>
    );
};

export default Summary;
